module.exports = __webpack_public_path__ + "img/huitre-en-ligne-boutrais.30730948.png";